import Multiple from './multiple'
import Single from './single'

const TextArea = {
  Multiple,
  Single
}

export default TextArea
